import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { ImageField, TextField } from './vms/CommonTypes';

interface Props {
  feedback: {
    feedback_image: ImageField;
    feedback_text: TextField;
  }[];
}

const HeaderFeedback: React.FC<Props> = ({ feedback }) => (
  <FeedbackRowWrap>
    {feedback.map((feedbackItem, index) => (
      <FeedbackWrap key={index}>
        <GatsbyImageStyled image={feedbackItem.feedback_image.gatsbyImageData} alt={feedbackItem.feedback_image.alt ?? ''} />
        <FeedbackTextWrap>{feedbackItem.feedback_text.text}</FeedbackTextWrap>
      </FeedbackWrap>
    ))}
  </FeedbackRowWrap>
);

export default HeaderFeedback;

const FeedbackRowWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 40px;
  flex-direction: row;
  gap: 20px;
  background: #e1eed3;
  border-radius: 100px;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const FeedbackWrap = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  gap: 10px;

  @media (max-width: 1024px) {
    height: 40px;
  }
`;

const FeedbackTextWrap = styled.div`
  font-family: BrownStd;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
`;

const GatsbyImageStyled = styled(GatsbyImage)`
  object-fit: contain;
  max-width: 50px;

  @media (max-width: 1024px) {
    max-width: 40px;
  }
`;
